import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DataGridTable } from "../../components/DataGridTable/DataGridTable";
import { ColumnText } from "../DataGridTable/ColumnText";
import { ColumnButton } from "../DataGridTable/ColumnButton";
import { HeaderGridTable } from "../DataGridTable/HeaderGridTable";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import ModalInfo from "./Modal/ModalInfo";
import { useDispatch, useSelector } from "react-redux";
import {
  JobTitle,
  resetFilters,
  setDialog,
  setFilters,
} from "../../app/slices/Job/jobTitleSlice";
import { useDebounce } from "use-debounce";
import AlertDialog from "../AlertDialog";

export const Tabel = () => {
  const dispatch = useDispatch();
  const {
    jobTitle: { data, filters, loading, total },
    manageJobTitle,
  } = useSelector((state) => state.jobTitle);
  const [search, setSearch] = useState(null);
  const [debouncedSearch] = useDebounce(search, 600);

  const columns = [
    {
      field: "name_en",
      headerName: "Name EN",
      headerClassName: "employer-grid--header",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
        return (
          <Box>
            <ColumnText
              text={params.row?.name_en}
              variant="subtitle1"
              fontWeight="bold"
            />
          </Box>
        );
      },
    },
    {
      field: "name_ar",
      headerName: "Name AR",
      headerClassName: "employer-grid--header",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <ColumnText
              text={params.row?.name_ar}
              variant="subtitle2"
              fontWeight="bold"
            />
          </Box>
        );
      },
    },
    {
      field: "job_field",
      headerName: "Job Field",
      headerClassName: "employer-grid--header",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <ColumnText
              text={params.row?.job_field?.name_en}
              variant="subtitle2"
              fontWeight="bold"
            />
          </Box>
        );
      },
    },
    {
      field: "operations",
      headerName: "Operations",
      flex: 1,
      minWidth: 100,
      headerClassName: "employer-grid--header",
      sortable: false,
      renderCell: (params) => {
        const [showConfirmDeleteModal, setShowConfirmDeleteModal] =
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useState(false);
        return (
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <ColumnButton
              onClick={() =>
                dispatch(
                  setDialog({
                    id: params.row.id,
                    name_en: params.row.name_en,
                    name_ar: params.row.name_ar,
                    job_field_id: params.row.job_field,
                  })
                )
              }
              type={"edit"}
            />
            <ColumnButton
              onClick={() => setShowConfirmDeleteModal(true)}
              type={"delete"}
            />
            <AlertDialog
              open={showConfirmDeleteModal}
              action={() => dispatch(JobTitle.deleteJobTitle(params.row.id))}
              handleClose={() => setShowConfirmDeleteModal(false)}
              title="Delete job title"
              message={`Are you sure you want to delete (${params.row?.name_en} - ${params.row?.name_ar})`}
            />
          </Box>
        );
      },
    },
  ];

  const fetchData = () => {
    dispatch(JobTitle.index());
  };

  useEffect(() => {
    if (debouncedSearch !== null) {
      dispatch(setFilters({ search: debouncedSearch }));
    }
  }, [debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    return () => {
      dispatch(resetFilters());
    };
  }, []);
  return (
    <>
      <Box m={2}>
        <HeaderGridTable
          title="Job Title"
          icon={<HomeWorkIcon size={25} color={"primary"} />}
          btn={"Add Job Title"}
          fetchData={fetchData}
          handleSearch={(e) => {
            setSearch(e.target.value);
          }}
          handleAdd={() => dispatch(setDialog())}
        />
        <Box mt={2}>
          <DataGridTable
            rowCount={total}
            rows={data}
            loading={loading}
            page={filters.page}
            columns={columns}
            pageSize={filters.take}
            onPageChange={(newPage) => {
              dispatch(
                setFilters({
                  skip: newPage * filters.take,
                  page: newPage,
                })
              );
            }}
            onPageSizeChange={(newPageSize) => {
              dispatch(
                setFilters({
                  take: newPageSize,
                })
              );
              if (filters.skip === 0) {
                dispatch(JobTitle.index());
              } else {
                dispatch(
                  setFilters({
                    skip: 0,
                    page: 0,
                  })
                );
              }
            }}
          />
        </Box>
        {/* Modal */}
        {manageJobTitle.dialog && <ModalInfo />}
      </Box>
    </>
  );
};

export default Tabel;
